<template>
  <div class="main-filters">
    <div class="title-primary">
      Filtros
    </div>
    <div class="row">
      <b-col cols="12">
        <p v-if="errors.show" style="color: red">
          <b>Por favor corrige los siguientes error(es):</b>
        <ul>
          <li v-for="(error, errorKey) in errors.data" :key="errorKey">
            {{ error }}
          </li>
        </ul>
        </p>
      </b-col>
      <div class="col-md-3">
        <div class="title-filters">
          Sindicato
        </div>
        <div class="baseline_box mb-2" tabindex="0">
          <label>Sindicato</label>
          <b-form-select id="SelectSyndicate" class="ml-1 mt-2 mb-1 SelectCategoria" @change="testHelloWord"
            :disabled="processingLaborUnions" v-model="selected_Syndicate">
            <option :value="null" disabled>
              -- Por favor seleccione una opción --
            </option>
            <option v-for="(option, indexOption) in getLaborUnions" :value="option" :key="indexOption">
              {{ option.name }}
            </option>
          </b-form-select>
        </div>
      </div>
      <div class="col-md-3" v-if="societyIsVisible">
        <div class="title-filters">
          Sociedad
        </div>
        <div class="baseline_box mb-2" tabindex="0">
          <label>Sociedad</label>
          <b-form-select id="SelectSyndicate" class="ml-1 mt-2 mb-1 SelectCategoria" value-field="id" text-field="name"
            @change="changeSociety" :disabled="processingSocieties" v-model="selectedSociety"
            :options="getLaborUnionSocieties" />
        </div>
      </div>
      <div class="col-md-4" v-if="selectedSociety !== null">
        <div class="title-filters">
          Periodo convencional
        </div>
        <div class="baseline_box mb-2" tabindex="0">
          <label>Perido convencional</label>
          <b-form-select id="SelectPeriodConventional" class="ml-1 mt-2 mb-1 SelectCategoria" value-field="id"
            text-field="name" @change="changePeriodCovencional" v-model="selectedPeriodConventional"
            :options="getPeriodConvertionals" />
        </div>
        <!-- <div class="d-flex select-datapicker">
          <div class="baseline_box mb-2 m-0" tabindex="0">
                <div class="position-relative">
                  <small class="text-input">Fecha inicial</small>
                  <b-form-datepicker
                          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                          id="datepicker-init"
                          :disabled="processing"
                          v-model="dateInit"
                          @input="dateRange"
                  ></b-form-datepicker>
                </div>
          </div>
          <div class="baseline_box mb-2 m-0" tabindex="0">
                <div class="position-relative">
                  <small class="text-input">Fecha final</small>
                  <b-form-datepicker
                          :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                          id="datepicker-end"
                          :min="dateInit"
                          :disabled="processing"
                          v-model="dateEnd"
                          @input="dateRange"
                  ></b-form-datepicker>                          
                </div>
          </div>
        </div> -->
      </div>
      <div class="col-md-3">
        <div class="title-filters">
          Nombre trabajador
        </div>
        <div class="baseline_box mb-2" tabindex="0">
          <label>Nombre, Cedula o SharpID</label>
          <b-form-select id="SelectSyndicate" class="ml-1 mt-2 mb-1 SelectCategoria" @change="testUser"
            text-field="name" :disabled="processing" v-model="selected_T">
            <option :value="null" disabled>-- Por favor seleccione una opción --</option>
            <option v-for="(option, i) in getEmployees" :value="option" :key="i">
              {{ option.name }}
            </option>
          </b-form-select>
        </div>
      </div>
      <div class="col-12">
        <button @click.prevent="clearFilter" class="button-danger">
          Quitar todos los filtros
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex"

export default {
  props: ['errors']
  , name: "Filters",
  data: () => ({
    selected_Syndicate: null,
    options_Syndicate: [
      { value: null, text: "Selecciona sindicato", disabled: true },
      { value: "", text: "sindicato 1" },
      { value: "sindicato 2", text: "sindicato 2" },
    ],
    selected_A: null,
    locale: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    dateInit: '',
    dateEnd: '',
    selected_T: {},
    options_T: [
      { value: null, text: "Selecciona", disabled: true },
      { value: "", text: "Tiquete 1" },
      { value: "Tiquete 2", text: "Tiquete 2" },
    ],
    errosx: [],
    processingLaborUnions: true,
    processing: true
    , societyIsVisible: false
    , processingSocieties: true
    , selectedSociety: null,
    selectedPeriodConventional: null
  }),
  computed: {
    ...mapGetters('permisosSindicalesStatisticsLaborsUnions', [
      'getLaborUnions',
      'getEmployees',
      'getGraphicDataUnion'
      , 'getLaborUnionSocieties',
      'getPeriodConvertionals'
    ])
  },
  async beforeMount() {
    this.processingLaborUnions = true
    this.selected_T = null
    await this.getTest().catch(({ response: { data: { message } } }) => {
      alert(message)
    }).finally(() => {
      this.processingLaborUnions = false
    })
  }
  , methods: {
    ...mapActions('permisosSindicalesStatisticsLaborsUnions', [
      'getTest',
      'getTestEmployee',
      'getLaborGraphicData'
      , 'clearFilters'
      , 'getLaborUnionsSocieties',
      'getPeriodConvetionals'
    ])
    , async changeSociety(id) {
      const me = this
      me.processing = true;
      me.selectedPeriodConventional = null;
      me.dateInit = '';
      me.dateEnd = '';
      me.selected_T = null;
      const selected_Syndicate = me.selected_Syndicate.id;
      try {
        await me.getTestEmployee({ id: selected_Syndicate, data: { society: id } });
        me.loadPeriodConvetionals(id, selected_Syndicate);
      } catch ({ response: { data: { message } } }) {
        alert(message)
      } finally {
        me.processing = false
      }
    }, 
    clearFilter() {
      const me = this
      if (
        me.selected_Syndicate !== null
        || me.dateInit !== ''
        || me.dateEnd !== ''
        || me.selected_T !== null
        || me.selectedPeriodConventional !== null
      ) {
        me.$emit('click:clear-filter')
        me.clearFilters()
        me.selected_Syndicate = null
        me.dateInit = ''
        me.dateEnd = ''
        me.selected_T = null
        me.selectedPeriodConventional = null
      }
    }, 
    async testHelloWord({ id, conventional_agreement }) {
      const me = this
      me.societyIsVisible = conventional_agreement;
      me.loadSocieties();
      me.$emit('change:sindicate-id', { id })

      if (
        conventional_agreement === false
      ) {
        me.processing = true
        await me.getTestEmployee({ id })
          .catch(({ response: { data: { message } } }) => {
            alert(message)
            console.clear()
          })
          .finally(() => {
            me.processing = false
          })
      }
      me.selectedSociety = null
      me.dateInit = ''
      me.dateEnd = ''
      me.selected_T = null
    },
    async loadSocieties() {
      const me = this;
      if (me.societyIsVisible) {
        me.processingSocieties = true
        await me.getLaborUnionsSocieties(me.selected_Syndicate.id)
          .catch(({ response: { data: { message } } }) => {
            alert(message)
          })
          .finally(() => {
            me.processingSocieties = false
          })
        me.dateInit = ''
        me.dateEnd = ''
        me.selected_T = null
        me.selectedPeriodConventional = null
      }
    },
    async testUser({ sharp_id, name, list_of_unions, identification_number, count_of_unions }) {
      this.$emit('change:user-selected', {
        sharp_id
        , name
        , list_of_unions
        , identification_number
        , count_of_unions
      })
    },
    async dateRange() {
      const me = this
      if (
        me.selected_Syndicate !== null
        && me.dateInit !== ''
        && me.dateEnd !== ''
      ) {
        const { id, conventional_agreement } = me.selected_Syndicate
        const dateEnd = me.dateEnd
        const dateInit = me.dateInit
        const society = me.selectedSociety
        const laborUnion = id
        const conventionalAgreement = conventional_agreement
        me.$emit('change:range-dates', {
          dateInit
          , dateEnd
          , society
          , laborUnion
          , conventionalAgreement
        })
      }

    },
    async loadPeriodConvetionals(societyId, laborUnionId) {
      const me = this;
      try {
        await me.getPeriodConvetionals({societyId, laborUnionId});
      } catch (error) {
        console.log(error)
      }
    },
    changePeriodCovencional(id) {
      const me = this;
      const record = me.getPeriodConvertionals.find(item => item.id === id);
      if (record) {
        me.dateInit = record?.initial_year;
        me.dateEnd = record?.end_year;
        me.dateRange();
      }
    }
  },
  created: function () {
    this.getTest()
  }
}

</script>

<style scoped>
.main-filters {
  /*  box-shadow: 0px 0px 4px 2px rgb(0 0 0 / 15%);
border-radius: 5px;*/
  padding: 25px;
  /* border-bottom: 1px solid #e9e9e9; */
  margin-bottom: 30px;
}

.title-primary {
  font-size: 24px;
  font-weight: 600;
}

.title-filters {
  border-bottom: 1px solid #CCC;
  color: #1C6776;
  display: inline-block;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top: 20px;
  font-family: Ubuntu;
  font-size: 22px;
  font-weight: 500;
}

.text-muted {
  position: relative;
  left: initial;
  top: 0;
  padding: 0;
  width: 100%;
  text-align: left;
}

@media (min-width: 992px) {
  .title-primary {
    text-align: left;
  }

  .title-filters {
    width: 100%;
    text-align: left;
  }
}

.baseline_box {
  margin-top: 0;
}

.select-datapicker {
  display: flex;
  column-gap: 10px;

}

.select-datapicker .baseline_box {
  flex: 50%;
  width: 50%;
  height: 43px;
}

.select-datapicker .month-picker-wrapper {
  min-width: 100%;

}


.vue-monthly-picker {
  font-family: Ubuntu;
  font-style: normal;
  font-weight: 300 !important;
  font-size: 16px;
  margin-top: 8px;
  padding-left: 10px;
}

.text-input {
  position: absolute;
  left: 16px;
  top: -6px;
  font: normal normal 300 12px/1 "Ubuntu";
  color: #78909C;
  background: #ffffff;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 4px;
  padding: 0px 4px;
  z-index: 9;
}

.button-danger {
  border-radius: 20px;
  padding: 4px 8px;
}
</style>